/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 用于打开由1.1版本稿件生成的1.1.1版本稿件，主要用于素材中心；
 * 区别于纯正的网站稿件（即直接在媒体栏目下写的稿子），由投稿上来转变为1.1.1版本的稿件走的是单独的审核流分支（storyToWebNews）
 * 主要用于编辑打开1.1.1版本稿件
 */
import React, {Component} from 'react';
import {message, Input, Button} from "antd";
import Editor from '../Editor'
import {base64Encode} from "../../../utils";
import WebEditor from "../webEditor/WebEditor";
import SyncModal from "../../../view/components/syncModal/syncModal";
import ButtonList from "../components/activitiAndBtn/ButtonList";
import {getInfoFromLocalStorage} from "../../../actions";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import {removeContentSecurity} from "../floatTool/securityCheck";
import {systemBaseEvent} from "../../../base/baseEvent";
import {formItemSizeConfig, informationConfig} from "../webEditor/form/information-config";
import EditorInformation from "../components/EditorInformation";
const {TextArea} = Input;

export default class MaterialCenterWebEditor extends WebEditor {
    static defaultProps = {};
    static propTypes = {};

    /**
     * 设置父页面传过来的参数作为编辑器中的数据回显
     */
    initParentData() {
        if (this.urlParams) {
            this.state.operateType = this.urlParams.operateType;
            this.state.storyId = this.urlParams.storyId;
            if(this.urlParams.webStory){
                this.state.webStory = this.urlParams.webStory;
                let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
                if(!id) {
                    this.setStoryByData(this.state.webStory);
                }
            }
            this.setState({});
        }
    };

    componentWillMount() {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let urlParams = this.urlParams;
        if(!id && !(urlParams && urlParams.storyId)) {
            this.initActivitiConfig({});
        }
    }

    /**设置流程配置*/
    async initActivitiConfig(story) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        this.state.id = id;
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        if (
            id &&
            (!story.id || story.id != id)
        ) { // 路径中存在稿件id,但是接口没有返回稿件参数或者参数中id不一致
            return false
        }
        // 发布按钮显示条件==============start
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (story.statusName && noPublishConfig.indexOf(story.statusName) > -1) ?false  : true
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 发布按钮显示条件================end
        // 判断操作权限==================start
        let showBtnFlag = false;
        let currentMediaList = getInfoFromLocalStorage("currentMediaList");
        if (!currentMediaList) {
            currentMediaList = await this.getCurrentMediaList()
        }
        let mediaId = this.state.mediaId || (story && story.mediaId);
        if (currentMediaList && currentMediaList.length) {
            if (currentMediaList.find(item => item && item.mediaList && item.mediaList.find(item2 => item2.id === mediaId))) {
                showBtnFlag = true;
            }
        }
        // 判断操作权限======================end
        // 重置流程条件====================start
        let againFlagData = await this.getAgainFlag({id});
        let againFlag = againFlagData && againFlagData.againFlag ? true : false;
        id = againFlagData && againFlagData.uuid ? againFlagData.uuid : id;
        let reloadStatus = this.sysConfigGetValueByKey("materialCenter.activiti.reload.status", "");
        if(story.statusName && reloadStatus.indexOf(story.statusName) > -1) { // 弃用状态重启审核流
            againFlag = true;
        }
        // 重置流程条件=====================end
        this.state.activityOption = {
            id,//流程id
            activitiConf: this.urlParams ? {type: this.urlParams.activitiConfName} : null,//流程conf
            pojoName: 'storyToWebNews',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                // call({code: 1});
                // call({code: 0, log: "非投稿稿件！"});
                // call({code: -1, log: "未获取到采访任务信息，请重新打开再试！"});
                /**
                 * 是否是投稿稿件来源（返回写稿人按钮显隐判定）
                 */
                fromContribute: (item, call) => {
                    // if (that.state.operateType && that.state.operateType === "contribute") {
                        call({code: 1});
                    // } else {
                    //     call({code: 0, log: "非投稿稿件！"});
                    // }
                },
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增稿件没有弃用权限！"});
                    }
                },
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 点击素材中心稿件标题进入的稿件
                    let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人");
                    // 稿件状态为返回写稿人
                    if (story && story.statusName && activitiConfName.includes(story.statusName)) {
                        call({code: 0, log: "不显示撤回按钮！"});
                        return
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                        let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                        if(myId === this.webStory.creator) {
                            message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                            window.loading.hide();
                            return false
                        }
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id: this.webStory.creator,
                            name: this.webStory.creatorName
                        }];
                        call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res) {
                                    message.success("流程已撤回，稿件变为草稿状态", 1, () => {
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
                /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    that.request({
                        url: "/cm-sites-sys/process/getProcessHistory",
                        method: "post",
                        body: {bizKey: uuid},
                        callBack: (data) => {
                            var historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                var callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        },
                        errorCallBack: () => {
                            message.error("未查询到返回者！");
                            window.loading.hide();
                        },
                    });
                },
            },//流程按钮点击事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            publish: that.publish,
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if (remarks && remarks.length) {
                    this.setState({showRemarks: true, remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: (mustNotShowPublishBtn1 || mustNotShowPublishBtn2) ? true : false,
            showBtnIcon: true,
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            btnType: "editor",
            chooseFilterObject: function(users, call) {
                if(!users || users.length<1) {
                    call&&call(users);
                    return false
                }
                let mediaInfo = that.getChooseFilterObject();
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,

                }));
                that.request({
                    url: "/cm-sites-pms/contribute/filterUser",
                    method: "post",
                    contentType: "json",
                    body: {
                        mediaInfo,
                        receivers
                    },
                    callBack: (list) => {
                        let newUsers = [];
                        if(list&&list.length) {
                            newUsers=list
                            call && call(newUsers)
                        } else {
                            message.warning("未查到拥有媒体权限的待办用户");
                            window.loading.hide();
                        }
                    },
                    errorCallBack: () => {
                        this.error("过滤媒体权限失败,请稍后重试");
                        window.loading.hide();
                    },
                });
            },
            checkForm: that.checkForm
        };
        this.setState({})
    }

    // 渲染稿件编辑器
    render() {
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {this.Editor = Editor}}
                // 动态参数（传递到子组件中）
                dynamicParams={{
                    editorId:this.state.id,
                    oldId:this.state.storyId,
                }}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块
                editorRightModule={this.renderEditorPublishInformation()}
                // 编辑器加载完毕的回调
                onEditorLoadOver={()=>{
                    // 向父页面请求媒体参数或稿件参数
                    // this.callPostMessage({
                    //     message: "请求媒体参数"
                    // });
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function(fun){
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    //接收参数去渲染数据  这里只能放在这里，因为必须等到编辑器加载完成了之后，才要把内容放在编辑器中
                    this.initParentData();
                    //接收id去渲染数据
                    this.getStoryById()
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content)=>{
                    this.setState({contentText:this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {this.setState({informationStatus: status})}}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
            />
        )
    }
    // 渲染稿件基本信息
    renderInformation = () => {
        return(
            <EditorInformation
                // 配置文件（输入框占比）
                informationConfig={informationConfig}
                // 配置文件（输入框大小）
                formItemSizeConfig={formItemSizeConfig}
                // 基本信息展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器内容
                contentText={this.state.contentText}
                // 标题的加号
                titleAddOrMinus={(call) => {
                    this.titleAddOrMinus(call)
                }}
                onLinkCheckedCall={(status)=>{
                    this.setState({editorShowStatus:status})
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                // 点击标题
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    treeId: this.state.treeId,
                    contentId: this.state.contentId,
                }}
                ref={(ref) => {
                    this.editorInformation = ref;
                    window.ueditor.getInformation = (check)=>this.editorInformation.getInformation(check);
                    window.ueditor.delAttachByMd5 = (md5)=>this.editorInformation.delAttachByMd5(md5);
                    window.ueditor.setFocus = (labelKey)=>this.editorInformation.setFocus(labelKey);
                    window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformation.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };
    // 点击查看编辑回调
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: () => {
                that.syncModal.destroy();
            },
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    };

    checkForm = (activiti, call) => {
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // 获取编辑器内容======================start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            return false
        }
        // 获取编辑器内容======================end

        // 获取基础属性===============start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            return false
        }
        // let {information, dynamicParams} = currentInformation;
        // dynamicParams = dynamicParams || {};
        if(this.webStory.variableFields){
            currentInformation.variableFields.formatId = this.webStory.variableFields.formatId;
        }
        // 获取基础属性=========end

        // 获取稿件id
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';

        // 获取发布设置start
        let publishData = this.getPublish();
        let {selectColumn, synchronousContribute=[],otherAttributes={}} = publishData;
        if(!selectColumn) {
            return false
        }
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let contentId = mainColumn.contentId||this.state.contentId;
        let contentName = mainColumn.contentName||this.state.contentName;
        let treeId = mainColumn.treeId||this.state.treeId;
        let treeName = mainColumn.treeName||this.state.treeName;
        let mediaId = mainColumn.mediaId||this.state.mediaId;
        let mediaName = mainColumn.mediaName||this.state.mediaName;
        let deliveryNews = selectColumn&&selectColumn.deliveryNews||[]; // 同步发布栏目

        // 发布时校验下线时间
        if(isPublish && otherAttributes.wbenddate) {
            if(otherAttributes.wbenddate < Date.now()) {
                window.loading.hide();
                message.warning("下线时间不能早于当前时间");
                return false
            }
        }
        // 获取发布设置end
        // 栏目信息校验（素材中心网站稿件：点击标题或者点击拾取）
        // 除了弃用和返回写稿人，其他操作需要选栏目
        let needColumnStatus = that.sysConfigGetValueByKey("editor.activiti.materialCenter.needColumnStates", "弃用,已弃用，返回写稿人,已返回写稿人");
        if(needColumnStatus.indexOf(statusNameTemp)==-1) {
            // 除了弃用和返回写稿人，其他操作需要选栏目
            if(!(mainColumn && contentId && treeId && mediaId)) {
                window.loading.hide();
                return (
                    message.destroy(),
                        message.warning("请先选择主栏目")
                )
            }
        }
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        let that = this;
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
        let isPublish = statusNameTemp && activitiConfName.indexOf(statusNameTemp)>-1;

        // 获取编辑器内容======================start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            call && call(false);
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call&&call(false);
            return false
        }
        // 获取编辑器内容======================end

        // 获取基础属性===============start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            call&&call(false);
            return false
        }
        // let {information, dynamicParams} = currentInformation;
        // dynamicParams = dynamicParams || {};
        if(this.webStory.variableFields){
            currentInformation.variableFields.formatId = this.webStory.variableFields.formatId;
        }
        // 获取基础属性=========end

        // 获取稿件id
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';

        // 获取发布设置start
        let publishData = this.getPublish();
        let {selectColumn, synchronousContribute=[],otherAttributes={}} = publishData;
        if(!selectColumn) {
            call&&call(false);
            return false
        }
        let mainColumn = selectColumn&&selectColumn.mainColumn||{}; // 主栏目
        let contentId = mainColumn.contentId||this.state.contentId;
        let contentName = mainColumn.contentName||this.state.contentName;
        let treeId = mainColumn.treeId||this.state.treeId;
        let treeName = mainColumn.treeName||this.state.treeName;
        let mediaId = mainColumn.mediaId||this.state.mediaId;
        let mediaName = mainColumn.mediaName||this.state.mediaName;
        let deliveryNews = selectColumn&&selectColumn.deliveryNews||[]; // 同步发布栏目

        // 发布时校验下线时间
        if(isPublish && otherAttributes.wbenddate) {
            if(otherAttributes.wbenddate < Date.now()) {
                window.loading.hide();
                message.warning("下线时间不能早于当前时间");
                call&&call(false);
                return false
            }
        }

        // 获取发布设置end
        // 栏目信息校验（素材中心网站稿件：点击标题或者点击拾取）
        // if(!(this.state.operateType && this.state.operateType === "contribute")) {
        //     // 从素材中心点击拾取进入了网站编辑器，走保存或发布时必须要选择主栏目，如果是点击标题不选栏目并保存，这篇稿件会继续在素材中心中显示但是无法进入融媒发布中；
        //     // 除了从素材中心标题进来的稿件，其他稿件在推进的时候都要选栏目
        //     if(!(mainColumn && contentId && treeId && mediaId)) {
        //         window.loading.hide();
        //         call&&call(false);
        //         return message.info("请先选择主栏目");
        //     }
        // }
        let url = '/cm-sites-pms/website/news/save';
        // if(activitiConfName.indexOf(statusNameTemp)>-1) {
        //     // 发布时必须选择主栏目
        //     if(!(mainColumn && contentId && treeId && mediaId)) {
        //         window.loading.hide();
        //         call&&call(false);
        //         return message.info("请先选择主栏目");
        //     }
        // }
        // 除了弃用和返回写稿人，其他操作需要选栏目
        let needColumnStatus = that.sysConfigGetValueByKey("editor.activiti.materialCenter.needColumnStates", "弃用,已弃用，返回写稿人,已返回写稿人");
        if(needColumnStatus.indexOf(statusNameTemp)==-1) {
            // 除了弃用和返回写稿人，其他操作需要选栏目
            if(!(mainColumn && contentId && treeId && mediaId)) {
                window.loading.hide();
                call&&call(false);
                message.destroy();
                message.warning("请先选择主栏目");
                return
            }
        }

        // 获取发布等状态
        let autoSaveStatsConfName = that.sysConfigGetValueByKey("webNew.activiti.autoSave.states", "发布,已发布,修改完成并提交");
        let autoSaveStats = statusNameTemp && autoSaveStatsConfName.indexOf(statusNameTemp)>-1;
        if(autoSaveStats) {
            url = '/cm-sites-pms/website/news/autoSave';
        }
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if (res.status) {
                    // 稿件数据 start
                    let params = {
                        ...this.state.webStory,
                        // // 文章标题
                        // "title": information.title,
                        // // 可变字段
                        // "variableFields": dynamicParams,
                        // // 附件
                        // "attach": information.attach,
                        // // 主栏目标题图
                        // "titlePic": information.titlePic,
                        // // 站群字段
                        // "wbextends": currentInformation.wbextends,
                        ...currentInformation,

                        //同步投递
                        "targetIds":synchronousContribute,
                        // 正文
                        "content": base64Encode(removeContentSecurity(res.content || content)),
                        // 稿件id
                        "id": id,
                        // 链接地址
                        "linkurl": "",
                        // 网站群的扩展字段
                        "wbextends": "",
                        // 投递信息（副栏目信息）
                        "deliveryNews": deliveryNews,
                        /**
                         * 主栏目设置==============================start
                         */
                        // 主媒体id
                        "mediaId": mediaId,
                        // 主媒体名
                        "mediaName": mediaName,
                        // 主栏目Id int
                        "treeId": treeId,
                        // 主栏目名
                        "treeName": treeName,
                        // 主资料源id int
                        "contentId": contentId,
                        // 主资料源名称
                        "contentName": contentName,
                        // 发布时间
                        "newdate": otherAttributes.newdate,
                        // 下线时间
                        "wbenddate": otherAttributes.wbenddate,
                        // 重要性 int
                        "wbweight": otherAttributes.wbweight,
                        // 是否头条 int
                        "wbfirst": otherAttributes.wbfirst,
                        // 头条结束时间
                        "wbfirstenddate": otherAttributes.wbfirstenddate,
                        // 头条开始时间
                        "wbfirststartdate": otherAttributes.wbfirststartdate,
                        // 是否置顶 int
                        "wbtop": otherAttributes.wbtop,
                        // 置顶开始时间
                        "wbtopdate": otherAttributes.wbtopdate,
                        // 置顶结束时间
                        "wbgotopdate": otherAttributes.wbgotopdate,
                        // 是否推荐 int
                        "wbrecommend": otherAttributes.wbrecommend,
                        // 点击量 int
                        "wbshowtimes": otherAttributes.wbshowtimes,
                        /**
                         * 主栏目设置==================================end
                         */
                    };
                    systemBaseEvent.syncExec("editorUpdateData");
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    // 稿件数据 end
                    this.request({
                        url,
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                // 更新稿件关系（网站稿件与收稿稿件
                                if(that.urlParams && that.urlParams.storyId) {
                                    that.updateStoryRelationByContent({
                                        body: {
                                            mediaNewsId: res.id, // 网站稿件id
                                            mediaNewsType: "webNews", // 网站媒体type
                                            operateType: that.state.operateType, // contribute 点击素材中心标题 / pickUp 点击拾取器
                                            storyId: that.urlParams.storyId, // 原稿件Id(副本）
                                        }
                                    });
                                }
                                that.state.id = res.id;
                                window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for(let i = 0 ; funs && i < funs.length; i++){
                                    let fun = funs[i];
                                    if(fun instanceof Promise){
                                        await fun(activiti, res, call);
                                    }else{
                                        fun(activiti, res, call);
                                    }
                                }
                                if(isPublish) {
                                    // url = '/cm-sites-pms/website/news/publish';
                                    // params.id = this.state.id;
                                    // this.securityCheckAsyncCheckAndPublish(params, activiti, res, call);
                                    this.securityCheckAsyncCheck({params, activiti, website:res, call});
                                }else{
                                    this.securityCheckAsyncCheck({params, activiti, website:res, call});
                                }
                                this.updateProcessAndData(this.publishData);
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
        //   window.ueditor.editRefresh()
    };

    // 更新稿件关系(拾取、复制）
    updateStoryRelationByContent = (config,call) => {
        if(config) {
            if(config.body) {
                this.request({
                    url:"/cm-sites-pms/story/saveRelation",
                    method:"post",
                    body: config.body,
                    callBack: (res) => {
                        if(res) {
                            call&&call(true);
                            console.log("更新稿件关系成功！")
                        }
                    }
                })
            }
        } else {
            call&&call(false);
        }
    };

}